<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ establishment.id ? "Editar" : "Novo" }} Estabelecimento
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Nome:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="establishment.establishment_name"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Nome do Profissional
                        Responsável pela Autorização:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="establishment.professional_name_authorization"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="Name">
                        <span class="required">*</span> Descrição do
                        Estabelecimento:
                      </label>
                      <textarea
                        class="form-control"
                        cols="30"
                        rows="3"
                        v-model="establishment.description_establishment"
                      ></textarea>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> CEP:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="establishment.zip_code"
                        placeholder=""
                        v-on:keyup="buscar"
                        v-mask="'99999-999'"
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Logradouro:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="establishment.address"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Bairro:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="establishment.neighborhood"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Número:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="inputNumero"
                        class="form-control"
                        v-model="establishment.number"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label for="Name"> Complemento: </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="establishment.complement"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name"> Ponto de Referência: </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="establishment.reference_point"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="EmailDomain">
                        <span class="required">*</span> UF:</label
                      >
                      <v-select
                        :options="ufs"
                        :reduce="(ufs) => ufs.id"
                        :label="'name'"
                        v-model="establishment.state_id"
                        v-on:input="getCities"
                        class="vselect"
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Cidade:
                      </label>
                      <v-select
                        :options="cities"
                        :reduce="(cities) => cities.id"
                        :label="'name'"
                        v-model="establishment.city_id"
                        class="vselect"
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label for="Name"> Telefone: </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="establishment.telephone"
                        placeholder=""
                        v-mask="'(99) 99999-9999'"
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name"> CNES: </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="establishment.cnes"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Situação do
                        Estabelecimento:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="establishment.establishment_situation"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Tipo do Estabelecimento:
                      </label>
                      <v-select
                        :options="type_establishments"
                        :reduce="
                          (type_establishments) => type_establishments.id
                        "
                        :label="'establishment_type_name'"
                        v-model="establishment.type_establishment_id"
                        class="vselect"
                      />
                    </div>
                  </div>
                  <div class="form-row mb-1">
                    <div class="col-md-6">
                      <label>Possui dificuldade de acesso ao local?</label>
                      <select
                        class="form-control"
                        v-model="establishment.access_difficulty"
                      >
                        <option value="SIM">Sim</option>
                        <option value="NÃO">Não</option>
                      </select>
                    </div>
                    <div
                      class="col-md-6"
                      v-if="establishment.access_difficulty == 'SIM'"
                    >
                      <label><span class="required">*</span> Qual?</label>
                      <input
                        v-model="establishment.difficulty_access_description"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Setor:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="establishment.sector"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Andar:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="inputNumero"
                        class="form-control"
                        v-model="establishment.floor"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Leito:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="inputNumero"
                        class="form-control"
                        v-model="establishment.bed"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-md-3">
                      <label>
                        <span class="required">*</span> Área de risco?</label
                      >
                      <select
                        class="form-control"
                        v-model="establishment.risk_area"
                      >
                        <option :value="true">Sim</option>
                        <option :value="false">Não</option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <label>
                        <span class="required">*</span> Comunidade?</label
                      >
                      <select
                        class="form-control"
                        v-model="establishment.community"
                      >
                        <option :value="true">Sim</option>
                        <option :value="false">Não</option>
                      </select>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Status:
                      </label>
                      <select
                        v-model="establishment.status"
                        class="form-control"
                      >
                        <option :value="1">Ativo</option>
                        <option :value="0">Inativo</option>
                      </select>
                    </div>
                  </div>

                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>Campos obrigatórios</strong>
                  </span>
                  <div class="block text-right">
                    <router-link to="/establishments" class="btn btn-back mr-1">
                      <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a v-if="$hasAbility('cadastro.gerenciar')" class="btn btn-add" @click="save">
                      Salvar
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";

export default {
  data() {
    return {
      establishment: {
        establishment_name: "",
        description_establishment: "",
        address: "",
        number: "",
        neighborhood: "",
        complement: "",
        zip_code: "",
        reference_point: "",
        telephone: "",
        cnes: "",
        establishment_situation: "",
        city_id: "",
        state_id: "",
        type_establishment_id: "",
        unit_health_id: "",
        access_difficulty: "NÃO",
        difficulty_access_description: "",
        sector: "",
        floor: "",
        bed: "",
        professional_name_authorization: "",
        latitude: "",
        longitude: "",
        risk_area: "",
        community: "",
        status: "1",
      },
      cities: [],
      ufs: [],
      type_establishments: [],
    };
  },
  computed: {},
  methods: {
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.establishment.zip_code)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.establishment.zip_code + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.establishment.address = self.endereco.logradouro;
            self.establishment.neighborhood = self.endereco.bairro;

            let api =
              self.$store.state.api +
              "cities?uf_code=" +
              endereco.ibge.substring(0, endereco.ibge.length - 1);

            axios
              .get(api)
              .then((response) => {
                console.log("aqui", response);
                self.establishment.state_id = response.data.data[0].uf_id;
                self.getCities();
                self.establishment.city_id = response.data.data[0].id;
              })
              .catch((error) => {
                self.$message(null, error.response.data, "error");
              });
            $("#inputNumero").focus();
          }
        );
      }
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "establishments";

      if (self.establishment.id) {
        self.establishment._method = "PUT";
        api += "/" + self.establishment.id;
      }

      self.$loading(true);

      axios
        .post(api, self.establishment)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/establishments");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getTypeEstablishments: function () {
      const self = this;
      let api =
        self.$store.state.api + "establishment_types?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.type_establishments = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUfs: function () {
      const self = this;
      let api = self.$store.state.api + "ufs?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.ufs = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCities: function () {
      const self = this;
      let api =
        self.$store.state.api +
        "cities?orderByAsc=name&paginated=false&status=1&uf_id=" +
        self.establishment.state_id;

      axios
        .get(api)
        .then((response) => {
          self.cities = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEstablishment: function (id) {
      const self = this;
      const api = self.$store.state.api + "establishments/" + id;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.establishment = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getUfs();
    self.getTypeEstablishments();

    let id = self.$route.params.id;
    if (id) {
      self.getEstablishment(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
};
</script>
<style scoped>
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 255, 128, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>